import { Injectable } from '@angular/core';
import { RecognitionFilter, DeviceSetting } from '../models';
import { Recognition } from '../models';
import { Observable } from 'rxjs';
import { Config } from '../config';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class LprService {

    constructor(
        private config: Config,
        private http: HttpClient
    ) { }

    searchRecognitions(filter: RecognitionFilter): Observable<Recognition[]> {
        return this.http.post<Recognition[]>(this.config.get('API_SERVER_URL') + "/recognition/search", filter);
    }

    countRecognitions(filter: RecognitionFilter): Observable<number> {
        return this.http.post<number>(this.config.get('API_SERVER_URL') + "/recognition/count", filter);
    }

    getReportFile(filter: RecognitionFilter): Observable<Blob> {
        return this.http.post<Blob>(this.config.get('API_SERVER_URL') + "/recognition/document", filter, { responseType: 'blob' as 'json' });
    }

    getDeviceSettings(): Observable<DeviceSetting[]> {
        return this.http.get<DeviceSetting[]>(this.config.get('API_SERVER_URL') + "/commons/devices");
    }

    loadImage(idRecognition: number): Observable<Blob> {
        return this.http.get<Blob>(this.config.get('API_SERVER_URL') + `/recognition/${idRecognition}/image.png`, { responseType: 'blob' as 'json' });
    }

    loadPlateImage(idRecognition: number): Observable<Blob> {
        return this.http.get<Blob>(this.config.get('API_SERVER_URL') + `/recognition/${idRecognition}/plate.png`, { responseType: 'blob' as 'json' });
    }
}
